import { EMAIL_CENTER_ACTIONS } from '@/constants/actions';
import { useEffect } from 'react';
import { useDispatch } from 'umi';

/**
 * The reference data the template editor renders against, fetched when the
 * drawer opens rather than with the page.
 *
 * Separate from `useEmailCenterReferenceData` (trigger types, variables,
 * languages) because these are the editor's own: partner translations and the
 * fragment catalogue are the bulk of what a preview resolves, and the journey's
 * `email_config.template_vars.*` is what the layout's chrome reads — a preview
 * without it renders the layout stripped of exactly the parts the recipient sees.
 *
 * All four are deduped in the model, so re-opening the drawer costs nothing.
 */
export function useTemplateDrawerData(
  visible: boolean,
  journeyHashId?: string | null,
): void {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!visible) return;
    dispatch({ type: EMAIL_CENTER_ACTIONS.FETCH_TRANSLATIONS });
    dispatch({ type: EMAIL_CENTER_ACTIONS.FETCH_FRAGMENTS });
    dispatch({ type: EMAIL_CENTER_ACTIONS.FETCH_EMAIL_SETTINGS });
    if (journeyHashId) {
      dispatch({
        type: EMAIL_CENTER_ACTIONS.FETCH_JOURNEY_EMAIL_CONFIG,
        payload: { journeyHashId },
      });
    }
  }, [visible, journeyHashId, dispatch]);
}

export default useTemplateDrawerData;
